import {Drawer, type DrawerProps, message, Space, Button} from 'antd';
import {useForm} from 'form-render';
import Style from './index.module.scss';
import {useMutation, useQuery} from 'react-query';
import {McpFunction} from '../McpFunDrawer/service';
import {isEmpty} from 'Stores/commonStore';
import useSchema from 'Utils/Hooks/useSchema';
import JsonForm from 'Components/JsonForm';

interface Props extends DrawerProps {
    onOk: () => void;
    id?: string;
    mcpId: string;
}

const Index = ({onOk, id, mcpId, ...props}: Props) => {
    const form = useForm();

    const onSave = useMutation({
        mutationFn: McpFunction.save,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const getData = useQuery({
        queryKey: ['McpFunction.detail', id],
        enabled: !isEmpty(id),
        queryFn: () => McpFunction.detail(id!),
        onSuccess: res => {
            form.setValues(res);
        },
    });

    const {schema} = useSchema({
        type: 'object',
        column: 1,
        displayType: 'row',
        labelCol: 5,
        fieldCol: 18,
        properties: {
            name: {
                title: '名称',
                required: true,
                type: 'string',
            },
            method: {
                title: '方法',
                required: true,
                type: 'string',
                widget: 'radio',
                enum: [...McpFunction.FieldTypeOptions],
                defaultValue: 'get',
            },
            url: {
                title: 'url',
                required: true,
                type: 'string',
            },
            dataIntro: {
                type: 'string',
                title: '数据格式说明',
                widget: 'textArea',
            },
            description: {
                type: 'string',
                title: '描述',
                widget: 'textArea',
            },
        },
    });

    function onFinish(formData: McpFunction.Form) {
        if (id) {
            formData.id = id;
        }
        formData.mcpId = mcpId;
        onSave.mutate({...formData});
    }

    function Extra() {
        return (
            <Space>
                <Button type="primary" onClick={form.submit}>
                    提交
                </Button>
            </Space>
        );
    }

    return (
        <Drawer
            {...props}
            extra={<Extra />}
            title={`${id ? '编辑' : '新增'} Mcp Function`}
            width={600}>
            <div className={Style.root}>
                <JsonForm
                    loading={getData.isLoading || onSave.isLoading}
                    onFinish={onFinish}
                    schema={schema}
                    form={form}
                />
            </div>
        </Drawer>
    );
};

export default Index;
